import React, { useState, useMemo } from "react";
import {
  FormGroup,
  FormControlLabel,
  Checkbox,
  Paper,
  Typography,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import BWITextField from "../shared/BWITextField";
import { State } from '../../state/reducers';
import { useSelector } from "react-redux";
import { System } from "../../state/types";

interface SystemAccessSelectorProps {
  selectedSystems: string[];
  onSystemSelect: (systemCode: string) => void;
  disabled?: boolean;
}

const SystemAccessSelector: React.FC<SystemAccessSelectorProps> = ({
  selectedSystems,
  onSystemSelect,
  disabled
}) => {
  const systems: System[] = useSelector((state: State) => state.systemState.systems);
  const [searchQuery, setSearchQuery] = useState("");

  // Fuzzy search filter logic for both systemCode & commonName
  const filteredSystems = useMemo(() => {
    const filtered = systems?.filter(
      (system) =>
        system.systemCode.toLowerCase().includes(searchQuery.toLowerCase()) ||
        system.commonName.toLowerCase().includes(searchQuery.toLowerCase())
    ) || [];

    return filtered.sort((a, b) => a.commonName.localeCompare(b.commonName));
  }, [searchQuery, systems]);


  return (
    <Paper elevation={2} sx={{ padding: 2, maxHeight: 300, overflowY: "auto" }}>
      {/* Search Input */}
      <BWITextField
        label="Search System Access"
        fullWidth
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
        sx={{ mb: 2 }}
        startIcon={<SearchIcon />}
      />

      {/* Checkboxes for system selection */}
      <FormGroup>
        {filteredSystems.map((system) => (
          <FormControlLabel
            key={system.systemCode}
            control={
              <Checkbox
                checked={selectedSystems.includes(system.systemCode)}
                onChange={() => !disabled && onSystemSelect(system.systemCode)}
                disabled={disabled}
                sx={{
                  "&.Mui-checked": {
                    color: "#d32f2f",
                  },
                }}
              />
            }
            label={
              <Typography variant="body2">
                <strong>{system.commonName}</strong> ({system.systemCode})
              </Typography>
            }
          />
        ))}
      </FormGroup>
    </Paper>
  );
};

export default SystemAccessSelector;
